'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _auditresultsummary = require('./auditresultsummary.component');

var _auditresultsummary2 = _interopRequireDefault(_auditresultsummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auditresultsummaryModule = _angular2.default.module('auditresultsummary', [_angularUiRouter2.default]).component('auditresultsummary', _auditresultsummary2.default);

exports.default = auditresultsummaryModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/auditresultsummary/auditresultsummary.js